import 'swiper/css'

import Swiper from 'swiper'
import {Expandable} from './Expandable.js'

import { trapFocus } from "./SvelteActions"

import { observeDarkBlocks } from './DarkBlocksObserver'

export class MainNavigation {
    
    get currentDepth() {
        return this._currentDepth
    }
    set currentDepth(val) {
        this._currentDepth = val
        this.$mainMenuDiv.style.setProperty('translate', `-${this._currentDepth}00%`)
    }
    constructor(breakpoint) {
        // console.log('MainMenu::constructor')
        this._currentDepth = 0

        this.$el = document.body.querySelector('.navigation-container')
        this.$burgerBtn = document.body.querySelector('#mainmenu-button')

        this.mobileDisplayQuery = window.matchMedia(breakpoint) // while the media query is true, menu is displayed as mobile
        
        this.init()
        
        this.cardBgLoaded = false
    }
    init() {
        if (this.$el) {
            this.$el.dataset.init = true
            this.$mainMenuDiv = this.$el.querySelector('#mainmenu') 
        }
        if (this.$burgerBtn) {
            const burgerBtn = new Expandable(this.$mainMenuDiv, {
                // debug: true,
                hasPopup: 'menu',
                on: {
                    open: ($menu) => {
                        if (!this.cardBgLoaded) {
                            const $card = this.$el.querySelector('.mainmenu__highlighted-post--card')
                            $card.style = $card.dataset.style
                            this.cardBgLoaded = true
                        }
                        
                        
                        // console.log('open!')
                        this.$el.dataset.state = 'open'
                        $menu.removeAttribute('inert')
                        
                        if (!this.mobileDisplayQuery.matches) { // desktop mode
                            this.$el.querySelector('.navbar__logo-link').setAttribute('inert', 'inert')
                            this.$el.querySelector('.mainmenu__highlighted-post--link').setAttribute('inert', 'inert')
                        }
                        
                        this.mainmenuTrapFocus = trapFocus($menu, [this.$burgerBtn])
                    },
                    close: ($menu) => {
                        // console.log('close!')
                        this.$el.dataset.state = 'closed'
                        const expandedSubmenus = [ ...this.$el.querySelectorAll('.submenu-region[data-expanded="true"]') ]
                        expandedSubmenus.forEach(_region => _region.expandable.close())
                        $menu.setAttribute('inert', 'inert')
                        
                        // remove inert in case it was set during desktop mode
                        this.$el.querySelector('.navbar__logo-link').removeAttribute('inert')
                        this.$el.querySelector('.mainmenu__highlighted-post--link').removeAttribute('inert')
                        
                        
                        this.mainmenuTrapFocus = this.mainmenuTrapFocus?.destroy()
                    }
                }
            }) // burger button behavior
            
            // init Expandables
            ;[ ...this.$el.querySelectorAll('.submenu-region') ].forEach($region => new Expandable($region, {
                on: {
                    open: (region) => {
                        region.removeAttribute('inert')
                        this.$mainMenuDiv.dataset.submenuExpanded = true
                        // this.mainmenuTrapFocus = trapFocus(region)
                    },
                    close: (region) => {
                        region.setAttribute('inert', 'inert')
                        this.$mainMenuDiv.dataset.submenuExpanded = false
                        // this.mainmenuTrapFocus = this.mainmenuTrapFocus?.destroy()
                    }
                }
            }) )
            ;[ ...this.$el.querySelectorAll('.accordion-region') ].forEach($panel => new Expandable($panel, {
                on: {
                    open: (panel) => panel.removeAttribute('inert'),
                    close: (panel) => panel.setAttribute('inert', 'inert')
                }
            }) )
        }
        
        observeDarkBlocks()

        
        this.setListeners()
        this.onMobileDisplayQueryChange(this.mobileDisplayQuery)
        
        
        // manage language switchers width
        const selectsArr = document.querySelectorAll('.lang-switch-nav__select')
        selectsArr.forEach(_$select => {
            this.updateSelectWidth({target: _$select})
        })
    }
    setListeners() {
        this.mobileDisplayQuery.addEventListener('change', this.onMobileDisplayQueryChange.bind(this), {capture: false, passive: true, once: false} || false)
        
        // ;[ ...document.querySelectorAll('[data-nav-forth]') ].map($btn => $btn.addEventListener('click', () => {
        //     this.currentDepth += 1
        //     document.getElementById($btn.getAttribute('aria-controls')).dataset.regionVisible = true
        // }, {capture: true, passive: true, once: false} || true))

        // ;[ ...document.querySelectorAll('[data-nav-back]') ].map($btn => $btn.addEventListener('click', () => {
        //     this.currentDepth -= 1
        //     document.getElementById($btn.getAttribute('aria-controls')).dataset.regionVisible = false
        // }, {capture: true, passive: true, once: false} || true))
    }
    onMobileDisplayQueryChange(e) {
        // this.currentDepth = this.currentDepth

        if (e.matches === true) { // mobile display
            this.$el.classList.remove('navigation-container--desktop-display')
        } else { // desktop display
            this.$el.classList.add('navigation-container--desktop-display')
        }
    }
    
    updateSelectWidth(e) {
        const $select = e.target
        const $selected = $select.querySelector(`option[value="${$select.value}"]`)
        
        const $auxOption = document.createElement('option')
        $auxOption.textContent = $selected.textContent
        
        const $auxSelect = document.createElement('select')
        $auxSelect.classList.add('link--l', 'lang-switch-nav__select')
        $auxSelect.append($auxOption)
        
        // const $auxSelectWrapper = document.createElement('nav')
        // $auxSelectWrapper.classList.add('other--dropdown', 'oce-dropdown-search__select-wrapper')
        // $auxSelectWrapper.append($auxSelect)
        
        // document.body.append($auxSelectWrapper)
        document.body.append($auxSelect)
        const width = window.getComputedStyle($auxSelect).width
        $auxSelect.remove()
        
        $select.style.width = width
    }
}


// TODO: clean up this Quick&Dirty mess
/* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
var prevScrollpos = window.pageYOffset



window.addEventListener('scroll', () => {
  var currentScrollPos = window.pageYOffset
  
  
  const navbar = document.querySelector('.navbar')
  if (!navbar) return
  
  if (currentScrollPos > 10
    && prevScrollpos < currentScrollPos 
    && document.body.querySelector('.navigation-container').dataset.state !== 'open' ) {
        navbar.classList.replace('visible', 'hidden') 
    } else { 
        navbar.classList.replace('hidden', 'visible')
    }
  prevScrollpos = currentScrollPos
  
}, {capture: false, passive: true, once: false} || false)

